import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#0d7583',
          light: '#44adbc',
          dark: '#24636c',
          contrastText: '#ffffff',
        },
        background: {
          default: mode === 'light' ? '#ededed' : '#222222',
        },
      },
      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },
    })
  )
}
